module.exports = function getResource(label, vars = []) {
    let resources = {
        new: 'NOUVEAUTÉ'
    };

    return resources[label];
};
